module.exports = __webpack_public_path__ + "img/tg.c4097dd7.svg";